module.exports = __webpack_public_path__ + "static/media/under-construction.72b35480.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Images/under-construction.gif
// module id = 797
// module chunks = 0